module.exports = __webpack_public_path__ + "static/media/background2.fb9d3464.png";